import { unsetTextStyleAttribute as e } from "../text-style-extension/utils/unset-text-style-attribute.mjs";
import { useFontFamilyExtensionToolbar as t } from "./use-font-family-extension-toolbar.mjs";
import { Extension as n } from "@tiptap/core";
//#region src/extensions/font-family-extension/index.ts
var r = n.create({
	name: "fontFamily",
	addOptions() {
		return { types: ["textStyle"] };
	},
	addGlobalAttributes() {
		return [{
			types: this.options.types,
			attributes: { fontFamily: {
				default: null,
				parseHTML: (e) => e.style.fontFamily?.replace(/['"]+/g, ""),
				renderHTML: (e) => e.fontFamily ? { style: `font-family: ${e.fontFamily}` } : {}
			} }
		}];
	},
	addCommands() {
		return {
			setFontFamily: (e) => ({ chain: t }) => t().setMark("textStyle", { fontFamily: e }).run(),
			unsetFontFamily: () => ({ tr: t, state: n, dispatch: r }) => e("fontFamily", n, t, r)
		};
	}
});
//#endregion
export { r as FontFamily, t as useFontFamilyExtensionToolbar };
